import type { Job } from '@mairistem/composants';
import type { TemplateRequestGet } from '@mairistem/finances-utils';
import { request } from '@mairistem/tools';
import type AutorisationCount from '../interfaces/common/autorisationCount';
import type AutorisationStatutCount from '../interfaces/common/autorisationStatutCount';
import type { EngagementCreditModal } from '../interfaces/common/EngagementCreditModal';
import type { MouvementCreditModal } from '../interfaces/common/MouvementCreditModal';
import type Projet from '../interfaces/common/projet';
import type TiersCreditPaiement from '../interfaces/creditPaiement/tiersCreditPaiement';
import type { DashboardData } from '../interfaces/dashboard/dashboardData';
import type TotauxPluriannuelle from '../interfaces/pluriannuelle/totauxPluriannuelle';

const url = '/api/finances/simulation/apcp/projets';

export const createProjet = (projet: Projet & { identifiantEntiteCompta: number }) =>
	request.post<Partial<Projet> & { identifiantEntiteCompta: number },	Projet>(url, projet);

export const getProjet = (identifiant: number, params: URLSearchParams) =>
	request.get<any, Projet>(`${url}/${identifiant}?${params.toString()}`);

export const getAutorisationCount = (params: URLSearchParams) =>
	request.get<any, AutorisationCount>(
		`${url}/getAutorisationCount?${params.toString()}`,
	);

export const getAutorisationStatutCount = (params: URLSearchParams) =>
	request.get<any, Omit<AutorisationStatutCount, 'toutes'>>(
		`${url}/getAutorisationStatutCount?${params.toString()}`,
	);

export const searchProjet = (params: URLSearchParams) =>
	request.get<any, TemplateRequestGet<Projet>>(
		`${url}/search?${params.toString()}`,
	);

export const updateProjet = (identifiant: number, projet: Projet, identifiantEntiteCompta: number) =>
	request.put<Partial<Projet> & { identifiantEntiteCompta: number }, Projet>(
		`${url}/${identifiant}`,
		{
			...projet,
			identifiantEntiteCompta,
		},
	);

export const getProjets = (params?: URLSearchParams) =>
	request.get<any, TemplateRequestGet<Projet>>(
		params ? `${url}/?${params.toString()}` : url,
	);

export const getProjetsInfosEngagements = (params: URLSearchParams) =>
	request.get<any, EngagementCreditModal>(
		`${url}/getProjetsInfosEngagements?${params.toString()}`,
	);

export const getProjetsInfosMandatements = (params: URLSearchParams) =>
	request.get<any, MouvementCreditModal>(
		`${url}/getProjetsInfosMandatements?${params.toString()}`,
	);

export const getCreditsPaiementsTotaux = (params: URLSearchParams) =>
	request.get<any, Projet>(
		`${url}/getCreditsPaiementsTotaux?${params.toString()}`,
	);

export const getTotauxPluriannuelle = (params?: URLSearchParams) =>
	request.get<any, TotauxPluriannuelle>(
		params
			? `${url}/totauxPluriannuelle?${params.toString()}`
			: `${url}/totauxPluriannuelle`,
	);

export const getPluriannuelleExportExcel = (params: URLSearchParams) =>
	request.get<any, Job>(`${url}/pluriannuelleExportExcel?${params.toString()}`);

export const getTableauBord = (params: URLSearchParams) =>
	request.get<any, DashboardData>(`${url}/tableauBord?${params.toString()}`);

export const reportEngagement = (params: URLSearchParams) =>
	request.get<any, any>(`${url}/reportEngagement?${params.toString()}`);

export const getTiersCreditPaiement = (params: URLSearchParams) =>
	request.get<any, TemplateRequestGet<TiersCreditPaiement>>(
		`${url}/tiersCreditPaiement?${params.toString()}`,
	);
